var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content__column" },
    [
      _vm._t("default", [
        _c("div", {
          staticClass: "content",
          domProps: { innerHTML: _vm._s(_vm.html) }
        })
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }